import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFileText } from '@fortawesome/free-solid-svg-icons';
import { DocumentoItem, TipoDocumento } from '../types';

interface DocumentItemProps {
  item: DocumentoItem;
  onUpdate: (id: string, field: keyof DocumentoItem, value: string) => void;
  onRemove: (id: string) => void;
}

const TIPOS_DOCUMENTO: { value: TipoDocumento; label: string }[] = [
  { value: 'Acta de Nascimento Espanhola emitida pelo Ministério da Justiça Espanhol', label: 'Acta de Nascimento' },
  { value: 'Certidão de Nascimento', label: 'Certidão de Nascimento' },
  { value: 'Certidão de Casamento', label: 'Certidão de Casamento' },
  { value: 'Certidão Negativa de Naturalização', label: 'CNN' },
  { value: 'Anexo I', label: 'Anexo I' },
  { value: 'Anexo III', label: 'Anexo III' },
  { value: 'Datos Nacimientos', label: 'Datos Nacimientos' },
  { value: 'Solicitud de Inscripción como residente', label: 'Solicitud' },
];

export const DocumentItem: React.FC<DocumentItemProps> = ({ item, onUpdate, onRemove }) => {
  return (
    <div className="document-item">
      <div className="document-item-header">
        <FontAwesomeIcon icon={faFileText} className="document-icon" />
        <span className="document-item-title">Documento</span>
        <button
          type="button"
          onClick={() => onRemove(item.id)}
          className="btn btn-remove"
          title="Remover documento"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      
      <div className="document-item-content">
        <div className="form-group">
          <label>Tipo de Documento:</label>
          <select
            value={item.tipo}
            onChange={(e) => onUpdate(item.id, 'tipo', e.target.value as TipoDocumento)}
            className="form-select"
            title="Selecione o tipo de documento"
          >
            {TIPOS_DOCUMENTO.map((tipo) => (
              <option key={tipo.value} value={tipo.value}>
                {tipo.label}
              </option>
            ))}
          </select>
        </div>
        
        <div className="form-group">
          <label>Nome do Titular:</label>
          <input
            type="text"
            value={item.nomeTitular}
            onChange={(e) => onUpdate(item.id, 'nomeTitular', e.target.value)}
            placeholder="Digite o nome do titular"
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
};
